import React, { useEffect, useState } from "react";
import { useBuilding } from "../../context/BuildingContext";
import { reportsApi } from "../../services/api";
import GenericReportViewer from "./GenericReportViewer";

interface Props {
  period: string;
}

const ShowTransactionsReport: React.FC<Props> = ({ period }) => {
  const { currentBuilding } = useBuilding();
  const [nominalCode, setNominalCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [report, setReport] = useState<any>(null);

  const load = async () => {
    if (!currentBuilding?.id || !nominalCode) return;
    try {
      setLoading(true);
      setError(null);
      setReport(
        await reportsApi.getShowTransactions(currentBuilding.id, {
          nominalCode,
          period,
        }),
      );
    } catch (e) {
      console.error(e);
      setError("Failed to load show transactions report.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="bg-white shadow rounded-lg p-4 mb-4 flex items-end gap-3">
        <div className="flex-1">
          <label className="block text-xs uppercase text-gray-500 mb-1">
            Nominal code
          </label>
          <input
            value={nominalCode}
            onChange={(e) => setNominalCode(e.target.value)}
            className="w-full border border-gray-300 rounded px-3 py-2"
            placeholder="e.g. 2001"
          />
        </div>
        <button
          onClick={load}
          disabled={!nominalCode || loading}
          className="bg-primary-600 hover:bg-primary-700 disabled:opacity-50 text-white px-4 py-2 rounded"
        >
          Run
        </button>
      </div>
      {(loading || error || report) && (
        <GenericReportViewer
          title="Show Transactions"
          loading={loading}
          error={error}
          report={report}
        />
      )}
    </div>
  );
};

export default ShowTransactionsReport;
